module.exports = __webpack_public_path__ + "static/media/cloud-d-v3.bc8d743c.svg";